package com.tixforgigs.common.ui.components.forms

import io.kvision.core.Container
import io.kvision.event.clickFlow
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.material.select.outlinedSelect
import io.kvision.material.select.selectOption
import io.kvision.material.slot.headline
import io.kvision.state.bind
import io.kvision.utils.perc
import io.kvision.utils.px
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.flow.update

@OptIn(ExperimentalMaterialApi::class)
fun <T> Container.outlinedSelect(
  label: String,
  items: List<T>,
  required: Boolean = false,
  disabled: Boolean = false,
  itemLabel: (T) -> String = { it.toString() },
  itemLeadingIcon: (T) -> String? = { null },
  initialSelectedItemIndex: (List<T>) -> Int = { -1 },
  onSelected: (T) -> Unit = {},
) {
  val selectedItem = MutableStateFlow(
    value = items.getOrNull(initialSelectedItemIndex(items))?.let { item ->
      itemLabel(item)
    }
  )

  outlinedSelect(
    label = label,
    required = required,
    disabled = disabled,
  ) {
    width = 100.perc
    marginBottom = 16.px
    
    items.forEachIndexed { index, item ->
      selectOption(
        value = itemLabel(item),
        selected = index == initialSelectedItemIndex(items)
      ) {
        //TODO comment in if material icon needed
        //leadingIcon("")

        //TODO comment in if image url needed
        /*itemLeadingIcon(item)?.let { imageSrc ->
          image(
            src = imageSrc
          ) {
            width = 24.px
            height = 24.px
          }
        }*/
        headline(itemLabel(item))
      }.clickFlow.onEach {
        selectedItem.update { itemLabel(item) }
        onSelected(item)
      }.launchIn(MainScope())
    }
  }.bind(selectedItem) { selectedItem ->
    value = selectedItem
  }
}
